import React from "react";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
// import Header from "../../components/Header/Header";
import Header from "../components/Header/Header.jsx";
import checkCnicAndMobile from "../pages/SwalHelper.js";  // Import the function
const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.73rem", // Decrease font size for small screens
      padding: theme.spacing(1, 4), // Decrease button padding for small screens
    },
  },

}));


function Layout({ open }) {

  const classes = useStyles();
  const navigate = useNavigate();

  const handleApply = () => {
    navigate("/form");
  };
  const handleUploadResult = async () => {
    try {
      const data = await checkCnicAndMobile();  // Use the imported function
      // Handle the data as needed
      console.log("Data:", data);
    } catch (error) {
      // Handle errors or user cancellation
      console.error(error.message);
    }
  };


  return (
    <>
      <div className="" style={{ width: open ? "88%" : "100%", margin:"20px auto"}}>
        <Header />
      </div>
      <div
        className="pt-8 sm:h-screen bg-gray-200 shadow-2xl shadow-slate-800 px-6 sm:px-20 rounded-md mt-16"
        // style={{ width: open ? "95%" : "100%" }}
        style={{ width: "95%", margin:"auto" }}
      >
        <div className="py-20">

        <p className="flex flex-col rounded-2xl bg-white text-center justify-center p-6  sm:p-20 text-2xl sm:text-4xl font-semibold">
          WELCOME TO THE ADMIN PANEL OF SINDH EDUCATIONAL ENDOWMENT FUND
        </p>
        </div>
        
        <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            fullWidth
            onClick={handleApply}
          >
            Apply Online for Scholarship
          </Button>
          <Button
    variant="contained"
    color="primary"
    size="large"
    className={classes.button}
    fullWidth
    onClick={handleUploadResult}  // Use handleUploadResult for "Upload Result" button
  >
    Upload Result
  </Button>
      </div>
    </>
  );
}

export default Layout;
